<template>
  <div class="home-container">
    <section class="hero-section">
      <div class="hero-content text-center">
        <img class="hero-logo" src="../assets/logo_v2.jpg" alt="Topsail Software Logo">
        <h1 class="hero-title">Software that Navigates the Future</h1>
        <p class="hero-subtitle">Southwest Nova Scotia's Premier Full-Stack & AI Development Shop</p>
        <div class="hero-actions">
          <a href="#products" class="btn-modern">Our Products</a>
          <a href="mailto:contact@topsailsoftware.ca" class="btn-modern outline">Get in Touch</a>
        </div>
        <br/>
        <br/>
      </div>
    </section>

    <section id="products" class="products-section container">
      <h2 class="section-title text-center mb-5">Our Core Products</h2>
      <div class="product-grid">
        <div class="product-card glass">
          <div class="card-content">
            <h3>Axes<sup>2</sup></h3>
            <p>The scoring solution of the Timber Lounge &amp; axe throwers around the world!</p>
            <a href="http://www.axes2.ca" target="_blank" class="link-arrow">Visit Axes2.ca &rarr;</a>
          </div>
        </div>

        <div class="product-card glass">
          <div class="card-content">
            <h3>Lighthouse</h3>
            <p>Next-generation Virtual Agents. Empower your business with AI-driven customer support and automation.</p>
            <a href="http://lighthouse.topsailsoftware.ca" target="_blank" class="link-arrow">Visit Lighthouse &rarr;</a>
          </div>
        </div>
      </div>
    </section>

    <section class="services-section container mt-5">
      <div class="glass p-5 rounded-lg">
        <h2 class="section-title text-center">Why Choose Topsail?</h2>
        <div class="row mt-4">
          <div class="col-md-4 text-center service-item">
            <h4>Full-Stack Web Apps</h4>
            <p>Robust, database-powered applications tailored to your specific business needs.</p>
          </div>
          <div class="col-md-4 text-center service-item">
            <h4>Artificial Intelligence</h4>
            <p>Cutting-edge AI integration to automate workflows and enhance decision making.</p>
          </div>
          <div class="col-md-4 text-center service-item">
            <h4>Custom Databases</h4>
            <p>Scalable data architecture designed for performance and security with robust analytics.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.home-container {
  padding-bottom: 4rem;
}

.hero-section {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at top right, rgba(99, 102, 241, 0.15), transparent 40%),
              radial-gradient(circle at bottom left, rgba(14, 165, 233, 0.15), transparent 40%);
}

.hero-logo {
  max-width: 200px; /* Adjust based on logo aspect ratio */
  margin-bottom: 2rem;
  border-radius: 20px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.hero-title {
  font-size: 3.5rem;
  line-height: 1.2;
  margin-bottom: 1rem;
  background: linear-gradient(to right, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: var(--text-muted);
  margin-bottom: 2.5rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-modern.outline {
  background: transparent;
  border: 1px solid var(--primary);
  color: var(--primary);
}

.btn-modern.outline:hover {
  background: rgba(14, 165, 233, 0.1);
}

.section-title {
  font-size: 2.5rem;
  margin-bottom: 3rem;
}

.products-section {
  padding-top: 5rem;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.product-card {
  padding: 2rem;
  border-radius: 16px;
  transition: transform 0.3s ease;
}

.product-card:hover {
  transform: translateY(-5px);
  background: rgba(15, 23, 42, 0.8);
}

.product-card h3 {
  color: var(--primary);
  margin-bottom: 1rem;
}

.product-card p {
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.link-arrow {
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}

.service-item h4 {
  color: var(--text-main);
  margin-bottom: 0.5rem;
}

.service-item p {
  color: var(--text-muted);
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2.5rem;
  }
}
</style>
